import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, FormLabel, TextField, InputAdornment } from '@mui/material';
import MultiLevelFormLabel from './multiLayerFormLabel';
import { Smartphone, Phone, LockOutlined } from '@mui/icons-material/';
import { FormatDefaultValuePhoneNumber, onFormatPhoneChange } from '../FieldFormat';

const ProfileForm = (props: { isCreating: boolean; formik: any; showEmail?: boolean }): JSX.Element => {
  const showEmail = props.showEmail !== false;
  const { t } = useTranslation('component');
  return (
    <>
      <Grid item xs={12}>
        <FormLabel htmlFor="FirstNameInput">{t('Form.FirstName')}</FormLabel>
        <TextField
          required
          fullWidth
          id="FirstNameInput"
          name="FirstName"
          value={props.formik.values.FirstName}
          onChange={props.formik.handleChange}
          error={props.formik.touched.FirstName && Boolean(props.formik.errors.FirstName)}
          helperText={props.formik.touched.FirstName && props.formik.errors.FirstName}
        />
      </Grid>

      <Grid item xs={12}>
        <FormLabel htmlFor="LastNameInput">{t('Form.LastName')}</FormLabel>
        <TextField
          required
          fullWidth
          id="LastNameInput"
          name="LastName"
          value={props.formik.values.LastName}
          onChange={props.formik.handleChange}
          error={props.formik.touched.LastName && Boolean(props.formik.errors.LastName)}
          helperText={props.formik.touched.LastName && props.formik.errors.LastName}
        />
      </Grid>

      <Grid item xs={12}>
        <MultiLevelFormLabel
          title={t('Form.PhoneNumber')}
          message={t('Form.PhoneNumberMessage')}
          for={'MobileNumberInput'}
        />
        <Grid container direction={{ xs: 'column', md: 'row' }} spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              //required={homePhoneRequired}
              //onBlur={homePhone}
              fullWidth
              id="MobileNumberInput"
              name="MobileNumber"
              value={FormatDefaultValuePhoneNumber(props.formik.values.MobileNumber)}
              placeholder={t('Form.MobileNumber').toString()}
              onChange={(event) => onFormatPhoneChange(event, props.formik.handleChange)}
              error={props.formik.touched.MobileNumber && Boolean(props.formik.errors.MobileNumber)}
              helperText={props.formik.touched.MobileNumber && props.formik.errors.MobileNumber}
              inputProps={{ maxLength: 14 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Smartphone fontSize="small" sx={{ marginRight: '10px' }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              //required={homePhoneRequired}
              //onBlur={homePhone}
              fullWidth
              id="HomeNumberInput"
              name="HomeNumber"
              placeholder={t('Form.PhoneNumber').toString()}
              value={FormatDefaultValuePhoneNumber(props.formik.values.HomeNumber)}
              onChange={(event) => onFormatPhoneChange(event, props.formik.handleChange)}
              error={props.formik.touched.HomeNumber && Boolean(props.formik.errors.HomeNumber)}
              helperText={props.formik.touched.HomeNumber && props.formik.errors.HomeNumber}
              inputProps={{ maxLength: 14 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone fontSize="small" sx={{ marginRight: '10px' }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Grid>

      {showEmail && (
        <Grid item xs={12}>
          <FormLabel htmlFor="EmailFormInput">{t('Form.Email')}</FormLabel>
          <TextField
            required
            disabled={!props.isCreating}
            fullWidth
            id="EmailFormInput"
            name="Email"
            autoComplete="email"
            placeholder="example@familiprix.com"
            value={props.formik.values.Email}
            onChange={props.formik.handleChange}
            error={props.formik.touched.Email && Boolean(props.formik.errors.Email)}
            helperText={props.formik.touched.Email && props.formik.errors.Email}
            InputProps={
              !props.isCreating
                ? {
                    endAdornment: (
                      <InputAdornment position="end">
                        <LockOutlined fontSize="small" />
                      </InputAdornment>
                    ),
                  }
                : {}
            }
          />
        </Grid>
      )}
    </>
  );
};

export default ProfileForm;
